// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YsOr","toggle":"styles_toggle__x2fiO","preview":"styles_preview__6iFx6"};